import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

// Removed unused FormField interface

interface LoginForm {
  email: string;
  password: string;
}

interface RequestForm {
  title: string;
  description: string;
  category: string;
  priority: 'low' | 'medium' | 'high';
  address: string;
  attachments: string[];
}

interface BidForm {
  amount: number;
  message: string;
  estimatedDuration: string;
}

interface FormsState {
  loginForm: LoginForm;
  requestForm: RequestForm;
  bidForm: BidForm;
}

const initialState: FormsState = {
  loginForm: {
    email: '',
    password: '',
  },
  requestForm: {
    title: '',
    description: '',
    category: 'maintenance',
    priority: 'medium',
    address: '',
    attachments: [],
  },
  bidForm: {
    amount: 0,
    message: '',
    estimatedDuration: '',
  },
};

const formsSlice = createSlice({
  name: 'forms',
  initialState,
  reducers: {
    updateLoginForm: (state, action: PayloadAction<Partial<LoginForm>>) => {
      state.loginForm = { ...state.loginForm, ...action.payload };
    },
    resetLoginForm: (state) => {
      state.loginForm = initialState.loginForm;
    },
    updateRequestForm: (state, action: PayloadAction<Partial<RequestForm>>) => {
      state.requestForm = { ...state.requestForm, ...action.payload };
    },
    resetRequestForm: (state) => {
      state.requestForm = initialState.requestForm;
    },
    updateBidForm: (state, action: PayloadAction<Partial<BidForm>>) => {
      state.bidForm = { ...state.bidForm, ...action.payload };
    },
    resetBidForm: (state) => {
      state.bidForm = initialState.bidForm;
    },
  },
});

export const {
  updateLoginForm,
  resetLoginForm,
  updateRequestForm,
  resetRequestForm,
  updateBidForm,
  resetBidForm,
} = formsSlice.actions;

export default formsSlice.reducer;
